import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import {IAugmentedJQuery} from "angular";
import {Kontekst} from "felles/tjenester/Kontekst";
import _ from "lodash";
import {gettextCatalog} from "angular-gettext";
import {Debugger} from 'debug'
import {CelleInfoMedData, HtmlPosisjon} from "./årshjul";

const debug: Debugger = require('debug')('ÅrshjulCellemeny');

export class ÅrshjulCellemeny {

    static visMeny(konfigurasjon:ÅrshjulCellemenyKonfigurasjon, $mdPanel: angular.material.IPanelService) {
        const panelPosition = $mdPanel.newPanelPosition().absolute();
        if (_.isString(konfigurasjon.pos.top)) panelPosition.top(konfigurasjon.pos.top);
        if (_.isString(konfigurasjon.pos.bottom)) panelPosition.bottom(konfigurasjon.pos.bottom);
        if (_.isString(konfigurasjon.pos.left)) panelPosition.left(konfigurasjon.pos.left);
        if (_.isString(konfigurasjon.pos.right)) panelPosition.right(konfigurasjon.pos.right);

        const panelAnimation = $mdPanel.newPanelAnimation()
            .withAnimation($mdPanel.animation.FADE);
        (<any>panelAnimation).duration(200);//duration er ikke definert i IPanelAnimation interfacet ..

        const panelKonfigurasjon = {
            attachTo: konfigurasjon.forelderelement,
            controller: ÅrshjulCellemeny.forInjisering(),
            controllerAs: '$ctrl',
            locals: {celle: konfigurasjon.celle, aar:konfigurasjon.år, callbacks: konfigurasjon.callbacks},
            position: panelPosition,
            animation: panelAnimation,
            template: require('./årshjulCellemeny.html'),
            clickOutsideToClose: true,
            escapeToClose: true,
            focusOnOpen: true
        };

        return $mdPanel.open(panelKonfigurasjon);
    }

    static forInjisering() {
        return [
            Kontekst.regNavn,
            regNavn.gettext.gettextCatalog,
            ÅrshjulCellemeny
        ]
    }

    constructor(private kontekst:Kontekst, private gettext:gettextCatalog) {
    }

    celle: CelleInfoMedData; //settes via bindings
    aar: string; //settes via bindings
    callbacks: ÅrshjulCellemenyCallbacks; //settes via bindings
    mdPanelRef: angular.material.IPanelRef; //settes via bindings

    gruppe(){
        return this.kontekst.finnAutentiserteGruppe(this.celle.ekstra.gruppeId);
    }

    klikkPaaNyttMoete() {
        this.callbacks.vedNyttMøte(this.celle);
        this.mdPanelRef.close();
    }

    klikkPaaNyttAarshjulinnslag() {
        this.callbacks.vedNyttÅrshjulinnslag(this.celle);
        this.mdPanelRef.close();
    }

    /*klikkPaaRedigerAarshjulinnslag() {
        this.callbacks.vedRedigerÅrshjulinnslag(this.celle);
        this.mdPanelRef.close();
    }*/

    /*klikkPaaSlettAarshjulinnslag() {
        this.callbacks.vedSlettÅrshjulinnslag(this.celle);
        this.mdPanelRef.close();
    }*/
}

export interface ÅrshjulCellemenyKonfigurasjon {
    celle: CelleInfoMedData;
    år: number;
    pos: HtmlPosisjon;
    forelderelement: IAugmentedJQuery;

    callbacks : ÅrshjulCellemenyCallbacks;
}

export interface ÅrshjulCellemenyCallbacks {
    vedNyttMøte: (celle: CelleInfoMedData) => void;
    vedNyttÅrshjulinnslag: (celle: CelleInfoMedData) => void;
    //vedRedigerÅrshjulinnslag: (celle: CelleInfoMedData) => void;
    //vedSlettÅrshjulinnslag: (celle: CelleInfoMedData) => void;
}
